import type { SelectHTMLAttributes } from "react";

import { ui } from "../lib/ui";

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  /** Extra classes for the wrapper (width, flex, …). */
  wrapperClassName?: string;
};

/** Native `<select>` with a Tailwind chevron. Keeps the OS popup (462
 *  branches need it) while matching the rest of the controls. */
export function Select({ wrapperClassName = "", className = "", ...rest }: Props) {
  return (
    <span className={`relative inline-flex items-center ${wrapperClassName}`}>
      <select className={`${ui.select} ${className}`} {...rest} />
      <svg
        aria-hidden="true"
        viewBox="0 0 16 16"
        className="pointer-events-none absolute right-2.5 size-3.5 text-muted"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 6l4 4 4-4" />
      </svg>
    </span>
  );
}
